module.exports = __webpack_public_path__ + "media/images/logo-sm-f4bf17c0ac8d815798c4a35369f66f48.png";